<template>
	<div class="cart popup_wrap" :class="{ 'cart--edit status--edit': orderEdit }" id="appCart">
		<div class="cart_in">
			<div class="cart_head relative" v-if="!orderEdit">
				<h2 class="title25">העגלה שלי</h2>
				<div class="cart_sub" :key="productsInCart" ref="productsincart">
					סה”כ {{ productsInCart }} מוצרים בעגלה
					<a href="javascript:void(0);" @click.prevent="clearCart">ניקוי עגלה</a>
				</div>
				<div class="cart_close close-animate">
					<a href="javascript:void(0);" onclick="closeCart();">
						<CLOSE />
					</a>
				</div>
			</div>
			<div class="cart_edit_note" v-if="false && orderEdit">
				<div class="edit_note_close close-animate">
					<a href="javascript:void(0);" @click="closeEdit">
						<CLOSE />
					</a>
				</div>
				<div class="cart_edit_top">בחרת לערוך את ההזמנה שלך.</div>
				<div class="cart_edit_bottom" id="orderCountdown">
					יש לך עוד
					<span class="hours"></span>:<span class="minutes"></span>:<span class="seconds"></span> שעות
					<br />לשלוח את ההזמנה המעודכנת.אפשר להוסיף, להסיר ולשנות כמויות של המוצרים בהזמנה, וגם לערוך את פרטי
					המשלוח.
				</div>
			</div>
			<div class="cart_head relative cart_head--edit" v-if="orderEdit">
				<h2 class="title25">עריכת הזמנה מס' {{ orderEditMeta.meta["doc_number"][0] }}</h2>
				<div class="cart_sub">
					סה”כ {{ productsInCart }} מוצרים בעגלה
					<a href="javascript:void(0);" @click.prevent="clearCart">ניקוי עגלה</a>
					<div class="cart_edit_details" v-if="orderEdit">
						<div class="flex flex--start">
							<div class="cart_edit_details__time">
								<div class="bold">מועד המשלוח</div>
								<span>{{ date }} {{ time }}</span>
							</div>
							<div class="cart_edit_details__street">
								<div class="bold">כתובת המשלוח</div>
								<span>{{ street }}</span>
							</div>
						</div>
					</div>
				</div>

				<a class="bt-cancel radius--100" @click.prevent="cancelEdit">ביטול עריכה</a>
				<div class="cart_close close-animate">
					<a href="javascript:void(0);" onclick="closeCart();">
						<CLOSE />
					</a>
				</div>
			</div>
			<div class="cart_edit_info" v-if="orderEdit">
				<img :src="wpData.assets_url + '/layout/info.png'" />
				רוצה להוסיף מוצר? יש לחפש אותו באתר כרגיל, להוסיף לעגלה ולהמשיך לסיום העריכה
			</div>
			<div class="cart_overview">
				<div id="scrollbar1" class="cart_scroll">
					<div class="viewport">
						<div class="overview">
              <div class="cart_row cart_shipping">
                <div class="right cart_title_wrap">דמי משלוח</div>
                <div class="left cart_col_total pr_price">
                  {{ shipmentCost | currency('') }}
                  <span class="currency">{{ currencySymol }}</span>
                </div>
                <div class="clearfix"></div>
              </div>
							<CartRow
								v-bind:product="product"
								v-for="product in products"
								v-bind:key="product.id"
							></CartRow>
						</div>
					</div>
				</div>
			</div>
			<div class="cart_bottom">
				<div
					id="product-recommendations-link"
					v-if="showProductRecommendationsLink"
					@click="gotoProductRecommendations"
				>
					<ARROW class="up-arrow" />
					<p class="text">{{ wpData.globalOptions.upsell_page.general.cart_link_text }}</p>
				</div>
				<div class="bt_total ease">
					<a href="#" @click.prevent="closeCart">
						{{ orderEdit ? "לסיום עריכת הזמנה" : "להזמנה מאובטחת" }}
						<span class="bt_total_num ease">
							{{ total }}
							<span class="currency">{{ this.wpData.currencySumbol }}</span>
              <span class="include-shipping">(סה"כ כולל משלוח)</span>
						</span>
					</a>
				</div>
				<div class="text">
					המחיר הסופי עשוי להשתנות לאחר שקילת המוצרים ביום המשלוח.
					<a href="#" @click.prevent="$modal.show('conditions')">לתנאים נוספים</a>
				</div>
				<div class="cart_shipp text">
					<b>מה דעתך לעשות את זה קבוע?</b>
					<br />העגלה הקבועה שלך, ביום ובשעה שנוחים לך
					<br />
					<a href>לפרטים נוספים</a>
				</div>
			</div>
		</div>
		<div class="bgblack" onclick="closeCartBG();"></div>
	</div>
</template>

<script>
	import Vuex, { mapState } from "vuex";
	import CartRow from "./CartRow";
	import CLOSE from "../../assets/img/close.svg";
	import ARROW from "../../assets/img/arrow_r.svg";
	import PerfectScrollbar from "perfect-scrollbar";
	import perOrderEdit from "../Popups/perOrderEdit";
	import hasPerOrder from "../Popups/hasPerOrder";
	import salesPopup from "../Popups/SalesPopup";
	import moment from "moment";

	export default {
		data() {
			return {
				wpData: wpData,
				doOnce: true,
				lastPrice: 0,
				showPromo: true,
        currencySymol: wpData.currencySumbol,
        shipmentCost: wpData.shipment_cost,
			};
		},
		beforeCreate() {},
		mounted() {

      window.ps = new PerfectScrollbar(".viewport", {
				wheelSpeed: 0.3,
				maxScrollbarLength: 60,
			});

			if (this.timeLeft && this.orderEdit) {
				let id = "orderCountdown";
				this.initializeClock(id, this.timeLeft.to);
			}

			if (this.$store.state.added.length > 0) {
				this.$store.state.showCartRecoveredNotice = true;
			}
		},
		updated() {
			this.$nextTick(() => {
				this.$store.dispatch("initToolTip");
				if (this.timeLeft && this.orderEdit) {
					let id = "orderCountdown";
					this.initializeClock(id, this.timeLeft.to);
				}
				if (!this.timeLeft && this.orderEdit && doOnce) {
					this.doOnce = false;
					this.$store.commit("setOrderEdit", false);
					this.$modal.show("timeup");
					this.closeEdit();
				}
			});
		},
		computed: {
			...mapState(["categories", "orderEdit", "orderEditMeta", "isAdmin", "permOrderEdit", "permOrder"]),
			...Vuex.mapGetters({
				productsInCart: "getNumberOfProducts",
				cart: "cartProducts",
				getProductById: "getProductById",
			}),
			date() {
				if (this.orderEdit) {
					return this.orderEditMeta.meta["jckwds_date"][0];
				}
				return "";
			},
			time() {
				if (this.orderEdit) {
					return this.orderEditMeta.meta["jckwds_timeslot"][0];
				}
				return "";
			},
			street() {
				if (this.orderEdit) {
					let html = "";
					if (this.orderEditMeta.meta["shipping_street"]) {
						html =
							"רח׳" +
							" " +
							this.orderEditMeta.meta["shipping_street"][0] +
							" " +
                (typeof this.orderEditMeta.meta["shipping_house"] === "undefined" ? '' : this.orderEditMeta.meta["shipping_house"][0]) +
							" ," +
							this.orderEditMeta.meta["_shipping_city"][0] +
							" ";
					} else {
						html =
							"רח׳" +
							" " +
							this.orderEditMeta.meta["billing_street"][0] +
							" " +
                (typeof this.orderEditMeta.meta["billing_house"] === "undefined" ? '' : this.orderEditMeta.meta["billing_house"][0]) +
							" ," +
							this.orderEditMeta.meta["_billing_city"][0] +
							" ";
					}
					return html;
				}
        return "";
			},
			products() {
				let pr = this.$store.state.added; // 8350
				pr.sort((a, b) => {
					let cat_a = a.categories;
					let cat_b = b.categories;
					return this.checkPosition(cat_a, cat_b);
				});

				return pr.filter(product => {
          return !product.is_coupon_product;
        });
			},
			total() {
				let totalSet = this.products.reduce((total, p) => {
					return total + parseFloat(this.calculatePrice(p));
				}, 0);
        let total = parseFloat(totalSet).toFixed(2);
        this.$store.commit("cartTotal", total );
        total = (parseFloat(total) + parseFloat(this.shipmentCost)).toFixed(2);

				return total;
			},
			checkMinimum() {
				if (this.total >= this.$store.state.minimumPriceForShipping) {
					return true;
				}
				return false;
			},
			userLogged() {
				return this.$store.state.userLogged;
			},
			timeLeft() {
				if (!this.orderEditMeta && !this.orderEditMeta.is_edit) {
					return null;
				}
				let date = this.orderEditMeta.meta.jckwds_date[0].split("/");
				let hour = this.orderEditMeta.meta.jckwds_timeslot[0].split(" - ")[0];
				let string_time = "20" + date[2] + "-" + date[0] + "-" + date[1] + " " + hour + ":00";
				let to = new Date(
					"20" + date[2],
					parseInt(date[1] - 1),
					date[0],
					parseInt(hour.split(":")[0] - 6),
					hour.split(":")[1]
				);
				let time = to.getTime();
				if (time) {
					return { date, hour, to, time };
				}
				return false;
			},
			showProductRecommendationsLink() {
				const conditions = [
					this.wpData.globalOptions.upsell_page.general.cart_link_enabled === true,
					this.$route.name !== "productRecommendations",
				];
				return conditions.every((i) => i == true);
			},
		},
		methods: {
			...Vuex.mapMutations(["clearCart"]),
			gotoProductRecommendations() {
				$(".cart_in").animate({ left: "-100%" }, 600, function () {
					$(".cart").fadeOut();
				});
				this.$router.push({ name: "productRecommendations" });
			},
			getTimeRemaining(endtime) {
				var t = Date.parse(endtime) - Date.parse(new Date());
				var seconds = Math.floor((t / 1000) % 60);
				var minutes = Math.floor((t / 1000 / 60) % 60);
				var hours = Math.floor(t / (1000 * 60 * 60));
				return {
					total: t,
					hours: hours,
					minutes: minutes,
					seconds: seconds,
				};
			},
			initializeClock(id, endtime) {
				var clock = document.getElementById(id);
				var hoursSpan = clock.querySelector(".hours");
				var minutesSpan = clock.querySelector(".minutes");
				var secondsSpan = clock.querySelector(".seconds");
				var _this = this;

				function updateClock() {
					var t = _this.getTimeRemaining(endtime);
					hoursSpan.innerHTML = ("0" + t.hours).slice(-3);
					minutesSpan.innerHTML = ("0" + t.minutes).slice(-2);
					secondsSpan.innerHTML = ("0" + t.seconds).slice(-2);

					if (t.total <= 0) {
						clearInterval(timeinterval);
					}
				}

				updateClock();
				var timeinterval = setInterval(updateClock, 1000);
			},
			checkPosition(cats1, cats2) {
				for (let index = 0; index < cats1.length; index++) {
					let category1 = this.categories.find((c) => c.id == cats1[index]);
					let category2 = this.categories.find((c) => c.id == cats2[index]);
					if (
						typeof category1 != "undefined" &&
						typeof category2 != "undefined" &&
						category1.position != "undefined" &&
						category2.position != "undefined"
					) {
						if (category1.position < category2.position) {
							return -1;
						}
						if (category1.position > category2.position) {
							return 1;
						}
					}
					return 0;
				}
			},
			calculatePrice(product) {
        if (!product.price) {
          return parseFloat(0);
        }
        if (
					(typeof product.salePriceTotal != "undefined" && product.salePriceTotal > 0) ||
					(typeof product.giftedProduct != "undefined" && product.giftedProduct > 0)
				) {
					return parseFloat(product.salePriceTotal).toFixed(2);
				}
				if ((product.type === "both" || product.type === "unitaskg") && product.selected === "unit") {
          return parseFloat(
						product.quantity * product.weight * parseFloat(product.price) * product.divide_by
					).toFixed(2);
				}
				return parseFloat(product.quantity * parseFloat(product.price) * product.divide_by).toFixed(2);
			},
			countdown() {
				let days, hours, minutes, seconds;
				var endDate = this.timeLeft.time;
				if (isNaN(endDate)) {
					return;
				}

				setInterval(calculate, 1000);

				function calculate() {
					let startDate = new Date();
					startDate = startDate.getTime();
					let timeRemaining = parseInt((endDate - startDate) / 1000);

					if (timeRemaining >= 0) {
						days = parseInt(timeRemaining / 86400);
						timeRemaining = timeRemaining % 86400;

						hours = parseInt(timeRemaining / 3600) + days * 24;
						timeRemaining = timeRemaining % 3600;

						minutes = parseInt(timeRemaining / 60);
						timeRemaining = timeRemaining % 60;

						seconds = parseInt(timeRemaining);

						document.getElementById("hours").innerHTML = ("" + hours).slice(0);
						document.getElementById("minutes").innerHTML = ("0" + minutes).slice(-2);
						document.getElementById("seconds").innerHTML = ("0" + seconds).slice(-2);
					} else {
						return;
					}
				}
			},
			closeEdit() {
				if (this.$route.name == "history") {
					this.$router.push("/");
				}
				$(".cart_in").animate({ left: "-100%" }, 600, function () {
					$(".cart").fadeOut();
				});
			},
			closeCart() {
				$(".cart_in").animate({ left: "-100%" }, 600, function () {
					$(".cart").fadeOut();
				});

        //if ( wpData.minimum_order.active && this.$store.state.cartTotal < parseFloat(wpData.minimum_order.amount) && !this.permOrderEdit && !this.orderEdit ) {
        //if ( wpData.minimum_order.active && this.$store.state.cartTotal < parseFloat(wpData.minimum_order.amount) && !this.permOrderEdit && !this.$store.state.permenantOrderEdit ) {
        if ( wpData.minimum_order.active && this.$store.state.cartTotal < parseFloat( wpData.minimum_order.amount ) ) {
          this.$modal.show("minimum-order");
          return;
        }

				if (this.permOrderEdit) {
					this.$modal.show(perOrderEdit, {});
					return;
				}
				if (
					typeof this.permOrder == "object" &&
					this.permOrder &&
					(this.permOrder.status == "1" || this.permOrder.status == 1)
				) {
					this.$modal.show(hasPerOrder, {});
					return;
				}
				if (this.orderEdit && this.orderEditMeta.meta.permenent_order[0]) {
					this.$router.push({ path: "checkout/permenent" });
					return;
				}

				// If checkout promotion popup is enabled and wasnt shown already in this session
				if (
					this.wpData.globalOptions.checkout_promo_enabled &&
					!sessionStorage.getItem("checkoutPromoWasShown")
				) {
					this.$modal.show(
						salesPopup,
						{
							is_checkout_promo: true,
							products: this.getCheckoutPromoProducts(),
							popup_title: this.wpData.globalOptions.checkout_promo_title,
							popup_subtitle: this.wpData.globalOptions.checkout_promo_subtitle,
							popup_cta: this.wpData.globalOptions.checkout_promo_cta,
							popup_redirect_to: this.userLogged && !this.isAdmin ? "checkout" : "orderEnter",
						},
						{
							name: "checkout-promo-popup", // Modal name
						}
					);

					// set local storage
					sessionStorage.setItem("checkoutPromoWasShown", Date.now());
					return;
				}

				// Handle upsell mid page between cart and checkout
				if (this.wpData.globalOptions.upsell_page.general.enabled) {
					if (!sessionStorage.getItem("upsellPageWasShown")) {
						const productRecommendationsRoute = {
							name: "productRecommendations",
						};
						if (this.userLogged) {
							this.$router.push(productRecommendationsRoute);
							return;
						} else {
							this.$router.push({
								name: "orderEnter",
								params: { redirectTo: productRecommendationsRoute },
							});
							return;
						}
					}
				}

				if (this.userLogged && !this.isAdmin) {
					this.$router.push({ name: "checkout" });
				} else {
					this.$router.push({ name: "orderEnter" });
				}
			},
			cancelEdit() {
				this.$store.commit("setOrderEdit", false);
        this.$store.commit("setCoupon", '');
        this.$store.commit("setGiftcard", '');
				this.clearCart();
				$(".cart_in").animate({ left: "-100%" }, 600, function () {
					$(".cart").fadeOut();
				});
			},
			getCheckoutPromoProducts() {
				// Get flashy user tags
				let userInfo = localStorage.getItem("user_info");
				let flashyTags = [];
				if (userInfo) {
					userInfo = JSON.parse(userInfo);
					if (userInfo.hasOwnProperty("flashy_tags") && Array.isArray(userInfo.flashy_tags)) {
						flashyTags = userInfo.flashy_tags;
					}
				}

				let records = [];
				let productsToShow = [];
				if (flashyTags.length > 0) {
					records = this.wpData.globalOptions.checkout_promo_records;
				}

				// Add products to show if a tag matches
				for (var i = 0; i < records.length; i++) {
					let record = records[i];
					if (flashyTags.includes(record.flashy_tag)) {
						productsToShow.push(...record.products);
					}
				}

				// Add default products to the 'productsToShow' array
				productsToShow.push(...this.wpData.globalOptions.checkout_promo_products);

				// Remove products that are already in cart and products that are null
				productsToShow = productsToShow.filter(
					(product) => product !== null && this.isProductInCart(product.id) === false
				);

				// Limit results to 2
				productsToShow = productsToShow.slice(0, 2);

				// If no items are left than show the first 2 from the default
				if (productsToShow.length === 0) {
					productsToShow = this.wpData.globalOptions.checkout_promo_products.slice(0, 2);
				}

				return productsToShow;
			},
			isProductInCart(productID) {
				if (!productID) {
					return false;
				}
				const cartItems = this.products;
				return typeof cartItems.find((cartItem) => cartItem.id == productID) === "object";
			},
		},
		components: {
			CartRow,
			CLOSE,
			ARROW,
		},
	};
</script>

<style scoped>
  .cart_shipping_price > div {
    display: inline;
    font-size: 14px;
    font-weight: bold;
  }
  .bt_total_num {
    line-height: 19px;
    height: 100%;
    padding: 7px 0;
  }
  .bt_total_num span.include-shipping {
    font-size: 12px;
    display: block;
  }
</style>

<style scoped lang="sass">
	@import '../../assets/sass/gift-card-abstracts.sass'

	#product-recommendations-link
		position: absolute
		top: -71px
		left: 0
		background-color: #efede9
		width: 100%
		padding: 0.65rem 0 .75rem 0
		border-top-right-radius: 1.5rem
		border-top-left-radius: 1.5rem
		box-shadow: 0 (-0.5rem) 1rem 0 rgba(0, 0, 0, 0.2)
		overflow: hidden
		line-height: 1
		cursor: pointer
		+mobile
			padding: 0.5rem 0
			top: -57px

		.up-arrow
			transition: transform 150ms ease-out
			transform: rotate(-90deg)
			height: 1.5rem
			fill: #395c2c
			margin-bottom: 0.25rem
			+mobile
				height: 1.25rem
				margin-bottom: 0

		.text
			font-size: 1.15rem
			font-weight: bold
			color: #395c2c

		&:after
			content: ''
			position: absolute
			bottom: -1rem
			left: 0
			width: 100%
			height: 1rem
			box-shadow: 0 0 0.75rem 0 rgba(0, 0, 0, 0.6)

	#product-recommendations-link:hover
		.up-arrow
			transform: rotate(-90deg) translateX(3px)
			fill: #1e824c
		.text
			color: #1e824c
</style>